import Check from '@mui/icons-material/Check';
import Remove from '@mui/icons-material/Remove';
import { Typography } from '@mui/material';
import { Suspense, lazy } from 'react';
import { PasswordRule, defaultRules } from 'utils/passwordRules';

type PasswordChecklistProps = {
  password: string;
  rules?: PasswordRule[];
  style?: any;
};

const PasswordStrengthBar = lazy(() => import('react-password-strength-bar'));

const Rule = ({ valid, text }: { valid: boolean; text: string }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {valid ? (
        <Check color="success" sx={{ marginRight: '4px' }} />
      ) : (
        <Remove color="disabled" sx={{ marginRight: '4px' }} />
      )}
      <Typography variant="body1" color={valid ? 'success.main' : 'text.disabled'}>
        {text}
      </Typography>
    </div>
  );
};

const PasswordChecklist = ({ password, rules = defaultRules, style }: PasswordChecklistProps) => {
  return (
    <>
      <div style={style}>
        <Typography variant="body1">Make sure your password meets the following criteria. </Typography>
        <div style={{ marginTop: 8 }}>
          {rules.map((rule, index) => (
            <Rule key={index} valid={rule.valid(password)} text={rule.text} />
          ))}
        </div>
      </div>
      <Suspense>{password && <PasswordStrengthBar password={password} />}</Suspense>
    </>
  );
};

export { PasswordChecklist };
